<template>
  <div class="home">
    <div class="head-bar">
      <Nav></Nav>
    </div>
    <div class="conts" style>
      <OrderHeader :photoCount="photoCount"></OrderHeader>
      <div class="content">
        <div class="daohang animate" :class="{'active':scrollTop>=130}">
          <div class="change-bar">
            <router-link class="item" to="/negative">底片({{allImgCount}}张)</router-link>
            <router-link class="item" to="/selected">已选({{selectedCount}}张)</router-link>
            <router-link class="item" to="/product">产品</router-link>
            <div class="right-btn">
              <button @click="showRule">选样须知</button>
              <button @click="downImg">
                <i class="icon-down text-bold" style="font-weight: bold"></i> 下载选片
              </button>
              <button class="black" @click="showTips" v-if="canRevise">提交选片</button>
            </div>
          </div>
        </div>
        <div>
          <router-view
            :scrollTop="scrollTop"
            class="router-view"
            :class="{'active':scrollTop>=130}"
            ref="routers"
          ></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Nav from "../components/nav.vue";
import OrderHeader from "../components/orderHeader.vue";

import DownImg from "../assets/js/downImg";

export default {
  name: "Home",
  components: { Nav, OrderHeader },
  data() {
    return {
      scrollTop: 0,
      canDown: true
    };
  },
  methods: {
    // 下载图片
    downImg() {
      let _this = this;
      if (this.canDown) {
        this.canDown = false;
        new DownImg(
          {
            name: "图片",
            list: _this.imgList.list
          },
          function() {
            _this.canDown = true;
          }
        );
      }
    },
    // 选样须知
    showRule(e) {
      // 提交选片小于约定
      let date = {
        type: "text",
        title: "选样须知",
        data: `
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>1.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        <div>2.流程</div>
        `
      };
      this.$my_message.show(date, e);
    },
    showTips(e) {
      let _this = this;
      let photoCount = this.photoCount;
      let date;
      if (this.selectedCount > photoCount[2].num) {
        // 提交选片大于约定
        date = {
          type: "",
          title: "保存选片",
          btns: ["确认支付", "我再想想"],
          data: `
        <div class='text-20'>已保存选片<span class='text-24 text-orange'>${
          _this.selectedCount
        }</span>张</div>
          <div class='text-18'>超过了套系约定精修<span class='text-orange'>${
            photoCount[2].num
          }</span>张，将产生额外费用</div>
          <div class='text-28 text-orange'>￥${(_this.selectedCount -
            photoCount[2].num) *
            20}</div>
        `,
          success: function(data) {
            console.log("确认支付");
            _this.makePay();
          }
        };
      } else if (this.selectedCount == photoCount[2].num) {
        // 提交选片等于约定

        for (let i = 0; i < this.seletedImgList.length; i++) {
          const element = this.seletedImgList[i];

          if (element.list.length == 0) {
            date = {
              type: "",
              title: "保存选片",
              btns: ["继续选片", "确认提交"],
              data: `
                    <div class='text-20'>${element.category +
                      "-" +
                      element.name}未选择任何照片</div>
                      <div class='text-20'>请为该产品选择照片</div>
                `,
              success: function(data) {
                console.log("确认支付");
                _this.makePay();
              },
              cancel: function(data) {
                console.log("取消");
              }
            };
            break;
          } else if (element.list.length < element.limit) {
            date = {
              type: "",
              title: "保存选片",
              btns: ["继续选片", "确认提交"],
              data: `
                    <div class='text-20'>${element.category +
                      "-" +
                      element.name}已保存选片<span class="text-24">${
                element.list.length
              }</span>张</div>
                      <div class='text-18'>该产品类别+约定${
                        element.limit
                      }张，还需继续选择</div>
          <div class='text-28 text-orange'>${element.limit -
            element.list.length}张</div>

               `,
              success: function(data) {
                console.log("确认支付");
              },
              cancel: function(data) {
                console.log("取消");
                _this.makePay();
              }
            };
            break;
          }
        }

        if (!date) {
          date = {
            type: "",
            title: "保存选片",
            btns: ["确认支付", "我再想想"],
            data: `
  <div class='text-20'>已保存选片<span class='text-24 text-orange'>${_this.selectedCount}</span>张</div>
    <div class='text-18'>确定要提交选片结果吗？</div>
  `,
            success: function(data) {
              console.log("确认支付");
              _this.makePay();
            },
            cancel: function(data) {
              console.log("取消");
            }
          };
        }
      } else {
        // 提交选片小于约定
        date = {
          type: "",
          title: "保存选片",
          btns: ["继续选片", "确认提交"],
          data: `
        <div class='text-20'>已保存选片<span class='text-24 text-orange'>${
          _this.selectedCount
        }</span>张</div>
        <div class='text-18'>约定套系精修<span class='text-orange'>${
          photoCount[2].num
        }</span>张，还需继续选择</div>
          <div class='text-28 text-orange'>${photoCount[2].num -
            _this.selectedCount}张</div>`,
          success: function(data) {
            console.log("继续选片");
          },
          cancel: function(data) {
            console.log("确认提交");
            _this.makePay();
          }
        };
      }

      this.$my_message.show(date);
    },
    makePay() {
      // 支付
      let _this = this;
      let storeData = {
        name: "店铺名称",
        price: "100",
        headUrl: "",
        payQrcode: "vsdvsdvdsv"
      };
      let pay = this.$my_message;
      pay.show({
        type: "pay",
        title: "扫码支付",
        data: storeData,
        success: function(data) {},
        cancel: function(data) {}
      });
      
      // 支付成功
      setTimeout(() => {
        // 设置用户不可再操作
        _this.$store.commit("setCanRevise", false);
        // 提交选片小于约定
        _this.$my_message.show({
          type: "success",
          title: "支付成功",
          data: `<div class='text-20' style='padding-top:20px'>支付成功，购买精修<span class="text-orange">${_this.selectedCount}</span>张</div>`,
          btns: ["我知道了"],
          success: function(data) {
            console.log("我知道了");
          }
        });
        // 支付失败
        // _this.$my_message.show({
        //   type: "stop",
        //   title: "选片已暂停",
        //   data:`<div class='text-20' style='padding:20px 0'>摄影师正在修改照片，请稍后再试或联系客服！</div>`,
        //   btns: ["我知道了"],
        //   success: function(data) {
        //     console.log("我知道了");
        //   }
        // });
      }, 3000);
    },
    scrollToTop(e) {
      this.scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
    }
  },
  computed: {
    allImgCount() {
      let all = this.$store.getters.getAllImgList;
      let cout = all.list.length;
      return cout;
    },
    selectedCount() {
      let all = this.$store.getters.getAllImgList;
      let cout = 0;
      for (let index = 0; index < all.list.length; index++) {
        const item = all.list[index];
        if (item.selected) {
          cout++;
        }
      }
      return cout;
    },
    photoCount() {
      let selectedCount = this.selectedCount;
      let allImgCount = this.allImgCount;
      return [
        {
          text: "底片",
          num: allImgCount
        },
        {
          text: "已选",
          num: selectedCount
        },
        {
          text: "精修",
          num: 10
        }
      ];
    },
    imgList() {
      return this.$store.getters.getAllImgList;
    },
    seletedImgList() {
      return this.$store.getters.getSeletedImgList;
    },
    canRevise() {
      return this.$store.getters.getCanRevise;
    }
  },
  mounted() {
    // this.$photoViewer()
    window.addEventListener("scroll", this.scrollToTop);
  }
};
</script>
<style lang="scss">
.home {
  background: $bg-grey;
  min-height: 100vh;
  .head-bar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;
    min-width: $min-width;
  }
  .conts {
    padding-top: 68px;
    padding-bottom: 20px;
  }
  .content {
    .change-bar {
      font-size: 14px;
      .item {
        display: inline-block;
        width: 132px;
        height: 45px;
        border: 1px solid rgba(236, 237, 240, 1);
        background: linear-gradient(
          0deg,
          rgba(244, 246, 250, 1) 0%,
          rgba(255, 255, 255, 1) 100%
        );
        border-radius: 4px;
        line-height: 45px;
        text-align: center;
        color: $text-black;
        margin-right: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      .router-link-active {
        background: #fff;
        border-bottom: none;
        width: 162px;
        padding-top: 5px;
        height: 50px;
        position: relative;
        font-size: 16px;
        font-weight: bold;
      }
      .router-link-active::after {
        content: "";
        position: absolute;
        width: 100%;
        height: 2px;
        background: #fff;
        bottom: -2px;
        left: 0;
      }
      .item:first-child.router-link-active {
        border-left: 5px solid #ff7800;
      }

      .right-btn {
        float: right;
        button {
          width: 132px;
          height: 40px;
          border: 1px solid rgba(236, 237, 240, 1);
          background: linear-gradient(
            0deg,
            rgba(244, 246, 250, 1) 0%,
            rgba(255, 255, 255, 1) 100%
          );
          border-radius: 4px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: $text-black;
          margin-left: 8px;
          cursor: pointer;
        }
        .black {
          background: rgba(27, 36, 49, 1);
          border: 1px solid rgba(39, 49, 66, 1);
          color: #fff;
        }
      }
    }
    .daohang {
      padding: 0 30px;
      padding-top: 10px;
      background: $bg-grey;
      &.active {
        position: fixed;
        background: #fff;
        width: 100%;
        top: 68px;
        min-width: $min-width;
        left: 0;
        z-index: 10;
        border-bottom: 1px solid rgba(231, 233, 237, 1);
        .item:first-child.router-link-active {
          border-left: 1px solid rgba(236, 237, 240, 1);
        }
        .router-link-active::after{
          bottom: 0;
        }
      }
    }
    
    .router-view {
      padding-bottom: 20px;
      padding: 0 30px;
      min-height: 100vh;
      &.active {
        padding-top: 18px;
      }
    }
  }
}
</style>
